interface Condition {
    conditionType: ConditionType;
    roundsRemaining: number;
    color: string;
}
